import {
  Button,
  CardActions,
  CardContent,
  CardMedia,
  Card,
} from "@mui/material";

import React, { useEffect } from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Constants from "../data/Constants";
import { getSingleCourse } from "../services/course.service";

function CourseCard(props) {
  const { course, hideActionBar, onClick, id, children, parentRef } = props;

  useEffect(() => {
    async function api() {
      try {
        if (!course && id) {
          course = await getSingleCourse(id);
        }
      } catch (error) {
        // error
        console.log(error);
      }
    }
    api();
  }, []);

  const navigate = useNavigate();

  const viewHandler = (e) => {
    navigate("/dashboard/course/view/" + course._id, {
      state: { course: course },
    });
  };

  const editHandler = (e) => {
    navigate("/dashboard/courses/edit/" + course._id);
  };

  return (
    course && (
      <Card
        sx={{ width: "300px",height:"320px", opacity: 1,display:"flex",flexDirection:"column",justifyContent:"space-between" }}
        className={props.className + " relative"}
        onClick={onClick}
      >
        <CardMedia
          component="img"
          className="object-cover"
          style={{ height: "150px" }}
          image={course.cover.url}
          draggable="false"
        />
        <CardContent className="">
          <div
            className="text-xsm uppercase font-bold bg-primary text-white px-2 absolute top-0 left-0"
            style={{
              borderRadius: "0px 0px 10px 0px",
            }}
          >
            {course.status}
          </div>
          <div className="text-lg font-bold text-ellipsis">
            {course.name}
          </div>
          <div className="text-xsm uppercase font-bold text-gray-800">
            {course.type} • {course.totalTopics} Topic
            {course.totalTopics > 1 && "s"} • {course.duration} min
            {course.duration > 1 && "s"}
          </div>

          <div className="text-gray-600 text-sm overflow-hidden truncate">
            {course.shortDescription}
          </div>
        </CardContent>
        <div className="flex">
          <div className="text-md font-bold  py-3 px-4 flex-grow">
            {course.salePrice
              ? Constants.CURRENCY_SYMBOL + course.salePrice
              : "FREE"}
          </div>
          {!hideActionBar && (
            <Button size="medium" onClick={editHandler}>
              <b>Edit</b>
            </Button>
          )}
        </div>
        {children}
        <div className=""></div>
      </Card>
    )
  );
}

export default CourseCard;
